import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'anf-core-react';

const mapMarkerPropTypes = {
  label: PropTypes.string,
  onMarkerClick: PropTypes.func.isRequired,
};

export default function MapMarker({
  label,
  onMarkerClick,
}) {
  return (

    <button
      type="button"
      className="fulfillment-map-marker"
      data-testid="fulfillment-map-marker"
      id={label}
      onClick={onMarkerClick}
    >
      <Icon icon="location-filled-anf" size="l" />
    </button>
  );
}
MapMarker.propTypes = mapMarkerPropTypes;
